
/*
	File generated by Typewriter automatically.
	Changes will be overwritten!
 */


export class User {

	public id: string;
	
	public userName: string;
	
	public firstName: string;
	
	public lastName: string;
	
}

